import {gql} from "@apollo/client";

const messageFragment = gql`
    fragment Message on MessageField {
        id
        text
        sender {
            id
            firstName
            profilePhoto
            accountRole
            country {
                id
                name
            }
            university {
                id
                name
            }
        }
        richContent {
            reply {
                senderId
                senderFirstName
                senderAccountRole
                messageId
                messageText
                messageCreated
                originalMessageText
                isSenderBlocked
            }
        }
        chatGroupId
        created
        visible
        read
        isSenderBlocked
        likes
        attachment {
            type
            payload {
                templateType
                buttons {
                    type
                    style
                    title
                    payload
                    inline
                }
                text
                relativePath
            }
        }
        deleted
    }
`;

export default messageFragment;
